<template>
	<div>
		
		<v-sheet color="transparent">
			<h2 class="cn-font grey--text">Arbeitsgruppen</h2>

			<p class="mt-2">Auf dieser Seite organisieren Sie Ihre Mitarbeiter in Arbeitsgruppen, um sie später leichter zu spezifischen Aufgaben einladen zu können.</p>
			<v-row>
				<v-col cols="12" md="8">
					<v-list v-for="group in groups" :key="group.id" class="mt-2 elevation-3">
						<v-list-item>
							<v-list-item-icon>
								<v-icon>mdi-account-group</v-icon>
								<v-badge :content="group.members.length || '0'" color="accent"></v-badge>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									{{group.name}}
								</v-list-item-title>
								<v-list-item-subtitle>{{group.description}}</v-list-item-subtitle>
							</v-list-item-content>
							<v-icon color="green" v-if="group.video_enabled">mdi-television</v-icon>

							<v-list-item-icon>
								<v-btn color="primary2" fab small @click="linkTo(`group/${group.id}`)">
									<v-icon color="white">mdi-arrow-right-bold</v-icon>
								</v-btn>
							</v-list-item-icon>
						</v-list-item>
					</v-list>
					<v-card-actions class="mt-4">
						<BackButton></BackButton>
						<v-spacer></v-spacer>
						<v-btn rounded class="elevation-1" color="accent" @click="new_group_dialog = !new_group_dialog" >
							Neue Arbeitsgruppe Anlegen
						</v-btn> 
					</v-card-actions>
					<v-dialog v-model="new_group_dialog" width="400px">
						<v-card>
							<DialogTitle title="Neue Arbeitsgruppe Anlegen" @close="new_group_dialog = false"></DialogTitle>
							<v-card-text>
								<GroupForm :doc="new_group_object" @change="(d) => new_group_object = d"></GroupForm>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn @click="saveNewGroup" color="accent" rounded>Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
				<v-col cols="12" md="4">
					<Tile title="Was sind Arbeitsgruppen?" :editable="false" width="100%">
						<template v-slot:content>
							<AboutGroups></AboutGroups>	
						</template>
					</Tile>
				</v-col>
			</v-row>
		</v-sheet>
		<People></People>
	</div>
</template>
<script>
	import Vuex from "vuex";
	import Tile from "@/components/elements/Tile"
	import BackButton from "@/components/elements/BackButton"
	import DialogTitle from "@/components/elements/DialogTitle"
	import People from "@/views/user/People"
	import AboutGroups from "@/components/assessment/content/AboutGroups"
	import GroupForm from "@/components/assessment/groups/GroupForm"
	// import Group from "@/components/assessment/Group.vue"
	export default {
		name: "Groups",
		components: {
			Tile, 
			GroupForm,
			People,
			BackButton,
			DialogTitle,
			AboutGroups
		}, 
		data: () => {
			return {
				new_group_dialog: false, 
				new_group_object: {
					name: "",
					assessment: "HhoSAanfneFrKeASrw8",
					description: "",
					members: []
				}
			}
		},
		computed: {
			...Vuex.mapState({
				groups: state => state.groups
			}),
		},
		methods: {
			saveNewGroup(){
				var group = this.new_group_object;
				group.id = this.generateId();
				group.assessment = "HhoSAanfneFrKeASrw8";
				group.members = []; 

				this.$store.dispatch("groups/add", group)
				this.new_group_dialog = false;
			}
		}
	}
</script>